import {
  customElement,
  FASTElement,
  Observable,
  observable,
  Splice,
  attr,
} from '@microsoft/fast-element';
import { logger } from '@genesislcap/foundation-comms';
import { RfqDetailModalTemplate as template } from './rfq-detail-modal.template';
import { RfqDetailModalStyles as styles } from './rfq-detail-modal.styles';
import { IRfqService } from '../../../services';
import { IRfq } from '../../../types';
import { IEnumService } from '../../../services/enum.service';
import { notifyError } from '../../../utils/notify';
import { CONTRACT_TYPE } from '../../../utils';

const name = 'rfq-detail-modal';

@customElement({
  name,
  template,
  styles,
})
export class RfqDetailModal extends FASTElement {
  @IRfqService rfqService: IRfqService;
  @IEnumService enumService: IEnumService;
  @observable show: boolean = false;
  @observable width: string = '390px';
  @observable title = 'RFQ Details';
  @observable data: IRfq = {} as IRfq;
  @attr newBuilds: String[] = [CONTRACT_TYPE.NEW_BUILD_VPPA, CONTRACT_TYPE.NEW_BUILD_PPA];

  private notifier: any;
  private handler: any;
  private idHandler: any;

  connectedCallback() {
    super.connectedCallback();
    this.showModalListener();
  }

  private showModalListener() {
    const _this = this;
    this.notifier = Observable.getNotifier(this.rfqService);
    this.handler = {
      handleChange(source: any, splices: Splice[]) {
        _this.show = source.rfqDetailModalVisibility;
      },
    };
    this.idHandler = {
      handleChange(source: any, splices: Splice[]) {
        const id = source.rfqDetailModelRfqId;
        if (id) {
          _this.getRfqData(id);
        }
      },
    };
    this.notifier.subscribe(this.handler, 'rfqDetailModalVisibility');
    this.notifier.subscribe(this.idHandler, 'rfqDetailModelRfqId');
  }

  private getRfqData(rfqId: string) {
    this.rfqService.getRfq(rfqId).then(
      (response) => {
        this.data = { ...response.REPLY[0] };
      },
      (error) => {
        notifyError(error);
        logger.error(error);
      },
    );
  }

  public closeModal() {
    this.data = {} as IRfq;
    this.rfqService.closeRfqDetailModal();
  }

  disconnectedCallback(): void {
    super.disconnectedCallback();
    this.rfqService.closeRfqDetailModal();
  }
}
